import getInstancesFromMap from '../../../../redux/utils/get-instances-from-map'
import WORKOUTS_PATH from '../../constants/path'
import { createSelector } from 'reselect'
import {
  compactObjectUtil,
  getObjectUtil
  , pickObjectUtil
} from 'packages/src'

const getRecommendedDomainMapWorkoutsSelect = createSelector(state => getObjectUtil(
  state,
  WORKOUTS_PATH.DATA
),
state => getObjectUtil(state, WORKOUTS_PATH.RECOMMENDED_DATA),
(domainMap, recommendedDomainListData) => {
  return {
    ...compactObjectUtil(pickObjectUtil(domainMap, recommendedDomainListData))
  }
}
)

export const getRecommendedWorkoutsSelect = createSelector(state => getObjectUtil(
  state,
  WORKOUTS_PATH.DATA
),
state => getObjectUtil(state, WORKOUTS_PATH.RECOMMENDED_DATA),
(domainMap, recommendedDomainListData) => {
  return getInstancesFromMap(domainMap, recommendedDomainListData)
}
)

export default getRecommendedDomainMapWorkoutsSelect
